/**
 * Where FTUX events go: ows-uxo's POST /api/v1/origin-experience (momentum-online ows_uxo/docs/EVENTS.md), or nowhere.
 * The path names no tracking word, so the owners' content blockers leave it alone; /api/v1/events is gone. The URL
 * is read from window.config only: a deploy may set `uxoEventsUrl`, and src/dev.js copies VITE_UXO_EVENTS_URL onto
 * it in dev, which keeps import.meta out of this module (jest compiles to CommonJS). Never keyed on
 * window.config.environment, which reads 'staging' on production.
 */

/**
 * With no URL configured, owners-hub's own hosts send to their cluster's ows-uxo: spark-test to spark-dev1's, production
 * to karajan-prod's, which takes app.whitelabels.com's pages only (its EVENTS_ORIGINS). Every other host sends nothing.
 */
const DEFAULT_EVENTS_URLS: ReadonlyMap<string, string> = new Map([
  [
    'owners-hub.spark-test.newtoncelestial.com',
    'https://ows-uxo.spark-test.newtoncelestial.com/api/v1/origin-experience',
  ],
  ['app.whitelabels.com', 'https://ows-uxo.prod-oh.newtoncelestial.com/api/v1/origin-experience'],
]);

export type UxoEndpointInput = {
  /** window.config.uxoEventsUrl, as configured (anything but a non-blank string counts as unset). */
  configUrl: unknown;
  /** location.host of the page. */
  host: string;
};

/** The configured URL; else the default of owners-hub's spark-test or production host; else null: no events. */
export const resolveUxoEndpoint = ({ configUrl, host }: UxoEndpointInput): string | null => {
  const configured = typeof configUrl === 'string' ? configUrl.trim() : '';
  if (configured) return configured;
  return DEFAULT_EVENTS_URLS.get(host) ?? null;
};

/** This page's events URL, or null: send nothing. */
export const uxoEndpoint = (): string | null =>
  resolveUxoEndpoint({ configUrl: window.config?.uxoEventsUrl, host: window.location.host });
